import React, { useEffect, useState } from 'react';
import { Button, Loader, Table, Tooltip } from '../../UiKit';
import { EmptyState } from '../commons';
import { InvalidSearchImg } from '../../images/images';
import { userModel } from '../../api';
import { upArrowIconGreen } from '../../images/images';
import Spinner from 'sushiweb/Spinner/Spinner';
import { Copy } from 'sushiweb/Icons';
import { copyToClipboard } from '../commons/CommonMethods';
import toast from 'react-hot-toast';
import { MetricsForJumboEvent } from '../../analytics/constants';
import { LoadMoreAddressesClickEvent } from '../../analytics/address-view/events';

const prevAddressesHeadings = [
  { name: 'Order Id', key: 1 },
  { name: 'Address', key: 2 },
  { name: 'Order Status', key: 3 },
  { name: 'Cancellation Reason', key: 4 },
  { name: 'Merchant Name', key: 5 },
];

const getAddressRow = (address) => {
  return {
    1: {
      title: address.order_id ? (
        <div
          role='button'
          tabIndex={0}
          style={{
            cursor: 'pointer',
          }}
          onClick={() => {
            window.open(
              `/lifeline?type=order_id&value=${address.order_id}`,
              '_blank',
            );
            return;
          }}
          className='tw-text-blue-600'
        >
          {address.order_id || '-'}
        </div>
      ) : (
        <div className='tw-flex tw-w-full tw-items-center tw-justify-center'>
          _
        </div>
      ),
    },
    2: {
      title: (
        <div className='tw-flex-gap' data-dd-privacy='mask'>
          <div className='tw-mb-2'>{address.delivery_address}</div>
          {address?.latitude && address?.longitude && (
            <div className='tw-flex tw-items-center tw-gap-2'>
              <button
                type='button'
                className='tw-flex tw-gap-2 tw-bg-white tw-items-center tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer'
                onClick={() =>
                  window.open(
                    `http://maps.google.com/?q=${address?.latitude},${address?.longitude}`,
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              >
                <span className='tw-text-grey-700 tw-font-regular tw-text-200'>
                  <span className='tw-font-medium tw-text-200'>Latitude :</span>{' '}
                  {address?.latitude}
                </span>
                <span className='tw-text-grey-700 tw-font-regular tw-text-200'>
                  <span className='tw-font-medium tw-text-200'>
                    Longitude :
                  </span>{' '}
                  {address?.longitude}
                </span>
                <span className='icon tw-w-5 tw-h-5 '>
                  <img src={upArrowIconGreen} alt='' />
                </span>
              </button>
              <Tooltip
                position='bottom'
                border={false}
                title={
                  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                  <span
                    onClick={() => {
                      copyToClipboard(
                        JSON.stringify({
                          latitude: address?.latitude,
                          longitude: address?.longitude,
                        }),
                      );
                      toast.success('Copied to clipboard');
                    }}
                    className='tw-cursor-pointer'
                  >
                    <Copy size={14} color={'#318616'} />
                  </span>
                }
                label='Click to copy Latitude and Longitude'
              />
            </div>
          )}
        </div>
      ) || (
        <div className='tw-flex tw-w-full tw-items-center tw-justify-center'>
          _
        </div>
      ),
    },
    3: {
      title: (
        <p
          className={`tw-px-3 tw-py-1 tw-rounded-lg ${
            address?.order_status === 'Delivered'
              ? 'tw-text-green-700 tw-bg-green-100'
              : address?.order_status === 'Cancelled'
              ? 'tw-text-red-700 tw-bg-red-100'
              : 'tw-text-blue-700 tw-bg-blue-100'
          }`}
        >
          {address.order_status}
        </p>
      ) || (
        <div className='tw-flex tw-w-full tw-items-center tw-justify-center'>
          _
        </div>
      ),
    },
    4: {
      title: address.status_msg || (
        <div className='tw-flex tw-w-full tw-items-center tw-justify-center'>
          _
        </div>
      ),
    },
    5: {
      title: <div data-dd-privacy='mask'>{address.merchant_name}</div> || (
        <div className='tw-flex tw-w-full tw-items-center tw-justify-center'>
          _
        </div>
      ),
    },
  };
};

const getPrevAddressesRows = (previousAddressesData) => {
  const rowsData = [];
  previousAddressesData &&
    previousAddressesData.map((address, index) => {
      const addressObj = getAddressRow(address);
      rowsData.push(addressObj);
      return true;
    });
  return rowsData;
};

const tabulateAddresses = (previousAddressesData) => {
  return {
    headings: prevAddressesHeadings,
    rows: getPrevAddressesRows(previousAddressesData),
  };
};

export const PreviousAddresses = ({ userId = null }) => {
  const [previousAddressesData, setPreviousAddressesData] = useState([]);
  const [hasMoreAddress, setHasMoreAddress] = useState(false);
  const [offset, setOffset] = useState(0);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState();
  const [nextCursor, setNextCursor] = useState(null);

  useEffect(() => {
    setLoading(true);
    const getpreviousAddressesData = () => {
      const queryParams = {};
      queryParams['user_id'] = userId;
      if (hasMoreAddress) {
        queryParams['offset'] = offset;
        queryParams['limit'] = 5;
        queryParams['next_cursor'] = nextCursor;
      }
      userModel
        .userPreviousAddresses(queryParams)
        .then((response) => {
          if (!response || (response && response.isError === true)) {
            setLoading(false);
            return setError(response);
          }

          setPreviousAddressesData([
            ...previousAddressesData,
            ...response.previous_address,
          ]);
          setHasMoreAddress(response.has_more_address);
          setNextCursor(response.next_cursor);
          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
    };

    getpreviousAddressesData();
  }, [userId, offset]);

  if (loading && !previousAddressesData?.length) {
    return <Loader />;
  }
  if (error) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={error?.message || 'No data available!'}
        isPop={true}
      />
    );
  }

  return (
    <div className='modalContent' data-dd-privacy='mask'>
      {previousAddressesData?.length > 0 && (
        <div className='tw-mb-4'>
          <Table tableData={tabulateAddresses(previousAddressesData)} />
        </div>
      )}

      {(!previousAddressesData || previousAddressesData?.length === 0) && (
        <EmptyState
          img={InvalidSearchImg}
          heading='No Previous Address Available'
          isPop={true}
        />
      )}
      {hasMoreAddress && nextCursor ? (
        <div className='tw-flex tw-items-center tw-justify-center tw-mt-5'>
          <div className='tw-w-full tw-flex tw-justify-center tw-items-center'>
            {loading ? (
              <Spinner color='#318616' size='small' />
            ) : (
              <Button
                title='Load more addresses'
                size='compressed'
                outline={true}
                onClick={() => {
                  LoadMoreAddressesClickEvent({
                    [MetricsForJumboEvent.customer_id]: userId,
                    [MetricsForJumboEvent.feature_meta]: {
                      current_address_count: previousAddressesData?.length || 0,
                    },
                  });
                  setOffset(() => previousAddressesData?.length || 0);
                }}
              />
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};
